import type { FormInstance } from 'antd/es/form/hooks/useForm';
import { useContext } from 'react';
import { SmxInspectorContext } from '../inspector-provider';

export const useValidateInspectorForm = (form?: FormInstance) => {
    const { setErrorInfo } = useContext(SmxInspectorContext);

    const validate = async () => {
        try {
            await form?.validateFields();
            setErrorInfo?.(undefined);
            return true;
        } catch (errorInfo) {
            console.log('Error validation:', errorInfo);
            setErrorInfo?.(errorInfo);
        }
        return false;
    };

    return {validate};
};
